import React from "react";
import { motion } from "framer-motion";

/**
 * Glassy mobile shell with a grain texture. We deliberately do NOT render a
 * faux status bar - on real phones the OS status bar (with real time and real
 * battery) already sits above the app viewport, so a fake copy duplicates the
 * info and clashes with the real OS values (fixed after Bobby's screenshot
 * showed the real 42% under a fake 100%).
 */
export default function MobileShell({ children, bottom }) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#1B1A18] px-2 py-2 sm:py-6">
      <div
        className="relative w-full max-w-[430px] min-h-[100dvh] sm:min-h-[860px] bg-sand-50 sm:rounded-[44px] sm:overflow-hidden sm:ring-1 sm:ring-black/10 sm:shadow-lifted grain"
        data-testid="mobile-shell"
      >
        <motion.div
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25 }}
          className="relative pt-3 pb-[100px] min-h-[100dvh] sm:min-h-[860px]"
        >
          {children}
        </motion.div>

        {bottom}
      </div>
    </div>
  );
}
